export function replaceWithX(str) {
  if (typeof str !== 'string' || !str) return '';

  return str.replace(/[\w\W]/g, 'X');
}
